export default __webpack_public_path__ + "static/media/06_shipto_requested_date.5e7a442a.png";